import actionComposer from 'utilities/actionComposer';
import { api_get_qcoligodoc_data } from 'features/reports/api';

export const GET_QCOLIGO_DOC_DATA = actionComposer('GET_QCOLIGO_DOC_DATA');
export const getQCOligoDocData = (orderId, search) => ({
  type: GET_QCOLIGO_DOC_DATA.type,
  payload: api_get_qcoligodoc_data(orderId, search)
});
